export type SauceRating = 1 | 2 | 3 | 4 | 5;
export type Nps = "promoter" | "passive" | "detractor";
export type DailyUse = "yes" | "maybe" | "no";
export type SauceType = "bourbon-apple" | "chimichurri" | "mustard" | "lexington";

export const SAUCE_TYPES: readonly SauceType[] = [
  "bourbon-apple",
  "chimichurri",
  "mustard",
  "lexington",
];

export interface SauceMeta {
  slug: SauceType;
  name: string;
  // Single-word version that fits on the bottle label SVG.
  bottleLabel: string;
  // Tailwind-friendly accent color used on the select cards and headings.
  accent: string;
  // Short tasting line, kept fun.
  blurb: string;
}

export const SAUCES: Record<SauceType, SauceMeta> = {
  "bourbon-apple": {
    slug: "bourbon-apple",
    name: "Bourbon Apple",
    bottleLabel: "BOURBON",
    accent: "#9b1b1b",
    blurb: "Sweet heat. Bourbon, apple, smoke.",
  },
  chimichurri: {
    slug: "chimichurri",
    name: "Chimichurri",
    bottleLabel: "CHIMICHURRI",
    accent: "#5d8a2a",
    blurb: "Bright, herby, garlicky.",
  },
  mustard: {
    slug: "mustard",
    name: "Mustard",
    bottleLabel: "MUSTARD",
    accent: "#d4a017",
    blurb: "Carolina gold. Tangy and warm.",
  },
  lexington: {
    slug: "lexington",
    name: "Lexington",
    bottleLabel: "LEXINGTON",
    accent: "#3a6fb0",
    blurb: "Vinegar-pepper. Old North State.",
  },
};

export interface SurveyAnswers {
  sauceType: SauceType;
  sauceRating: SauceRating;
  likedMost: string | null;
  dailyUse: DailyUse;
  dailyUseComment: string | null;
  nps: Nps;
}

export interface ScanRecord {
  eventSlug: string;
  sauceType: SauceType;
  ratedAt: string; // ISO 8601 UTC
  sauceRating: SauceRating;
}

export interface FeedbackSubmission extends SurveyAnswers {
  eventSlug: string;
  deviceUuid: string;
  scannedAt: string;
  marketingOptIn: boolean;
  contactName: string | null;
  email: string | null;
  phone: string | null;
  zip: string | null;
}

export interface FeedbackResponse {
  ok: true;
  status: "created" | "duplicate";
}

// Session upsert — sent on Welcome submit and again on Wrap-up.
// Any field can be omitted; nulls leave the existing value untouched.
export interface SessionUpsert {
  eventSlug: string;
  deviceUuid: string;
  contactName?: string | null;
  email?: string | null;
  phone?: string | null;
  zip?: string | null;
  marketingOptIn?: boolean;
  brandWords?: string | null;
  completed?: boolean;
}

export interface CachedContact {
  name: string;
  email: string;
  phone: string; // formatted display value, e.g. "(555) 123-4567"
  zip: string;
  marketingOptIn: boolean;
}
